import React from "react";

const LikeIcon = ({ fill }) => {
  return (
    <svg
      className=" transition-all"
      width="16.991"
      height="16.868"
      viewBox="0 0 16.991 16.868"
    >
      <g id="like" transform="translate(0.766 0.783)">
        <g id="Heart">
          <path
            id="Path_33961"
            d="M7.537,15.21a28.569,28.569,0,0,1-4.9-3.995A10.293,10.293,0,0,1,.3,7.326C-.569,4.472.451,1.21,3.313.245a4.689,4.689,0,0,1,4.418.777h0A4.7,4.7,0,0,1,12.143.245c2.862.965,3.889,4.227,3.017,7.081a10.293,10.293,0,0,1-2.332,3.893,28.567,28.567,0,0,1-4.9,3.99l-.191.124Z"
            transform="translate(-0.001 0.001)"
            fill={fill}
            stroke="#00ad67"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default LikeIcon;
